import React, { Component } from 'react';
import {formatAmount} from '../../../services/helpers';

class StepNumber extends Component {

    constructor(props) {
        super(props);
    }

    render() {

        const {currentStep, resume} = this.props;

        return (
            <ol className="progressbar">
                <li className={currentStep === 1 && `current`} onClick={(e) => { this.props.step(1) }}>
                    <p>{resume.number.length > 0 ? resume.number : 'Número'}</p>
                </li>
                <li className={currentStep === 2 && `current`} onClick={(e) => { this.props.step(2) }}>
                    <p>{resume.amount.value > 0 ? formatAmount(resume.amount.value) : 'Valor'}</p>
                </li>
                <li className={currentStep === 3 && `current`} onClick={(e) => { this.props.step(3) }}>
                    <p> {resume.payment.id > 0 ? resume.payment.flag + ' ' + resume.payment.digFour : 'Pagamento'}</p>
                </li>
            </ol>
        );
    }

}

export default StepNumber